/**
 * HTML sanitization utilities
 * Uses DOMPurify to prevent XSS attacks
 */
import DOMPurify from 'dompurify'

/**
 * Sanitize HTML content before storage/display
 * Whitelist safe tags and attributes to prevent XSS
 */
export function sanitizeHTML(html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      'p',
      'br',
      'strong',
      'em',
      'u',
      's',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'ul',
      'ol',
      'li',
      'a',
      'img',
      'blockquote',
      'code',
      'pre',
    ],
    ALLOWED_ATTR: [
      'href',
      'target',
      'rel', // Links
      'src',
      'alt',
      'width',
      'height', // Images
    ],
    ALLOW_DATA_ATTR: false,
  })
}
